@for (component of tab4(); track component) {
  @if (displayGrants(component)) {
    <esp-deposit-form-section sectionTitle="{{'funding.title' | customTranslate}}"
      [required]="isRequired(component)">
      <esp-deposit-grants></esp-deposit-grants>
    </esp-deposit-form-section>
  }
}
